import type { FilterCondition, FilterParams } from "epsm-api-types";
import { NEWS_CATEGORY, NEWS_DATASET } from "../../../types";

export function getNewsFilterByCategory(
	categories?: (NEWS_CATEGORY | NEWS_DATASET.AI_ANALYSIS)[],
): FilterParams {
	if (!categories?.length) return [];

	const allCategoryFilters: NEWS_CATEGORY[] = [];
	const aiAnalysisFilters: NEWS_DATASET[] = [];

	for (const category of categories) {
		if (category === NEWS_DATASET.AI_ANALYSIS) {
			aiAnalysisFilters.push(NEWS_DATASET.AI_ANALYSIS);
		} else if (category === NEWS_CATEGORY.MANAGEMENT) {
			allCategoryFilters.push(NEWS_CATEGORY.EXECUTIVE, NEWS_CATEGORY.PERSONNEL);
		} else {
			allCategoryFilters.push(category);
		}
	}

	return [
		...(allCategoryFilters.length
			? [
					{
						name: "category",
						condition: "in" as FilterCondition,
						value: allCategoryFilters,
					},
				]
			: []),
		...(aiAnalysisFilters.length
			? [
					{
						name: "dataset",
						condition: "eq" as FilterCondition,
						value: NEWS_DATASET.AI_ANALYSIS,
					},
				]
			: []),
	];
}
